/**
 * Individual
 */

import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Form } from 'react-bootstrap';
import IconButton from 'components/interaction/IconButton/index.jsx';
import messages from './messages.js';

function Individual(props) {
  const { onSubmit, userId, multiple } = props;
  const [emailAddresses, setEmailAddresses] = useState(['']);
  const intl = useIntl();

  function setEmailAddress(email, i) {
    setEmailAddresses(emailAddresses.map((e, j) => i === j ? email : e));
  }

  function handleRemove(i) {
    setEmailAddresses(emailAddresses.filter((e, j) => i !== j));
  }

  const handleAdd = useCallback(() => {
    setEmailAddresses([...emailAddresses, '']);
  }, [emailAddresses]);

  async function handleSubmit(ev) {
    ev.preventDefault();
    await onSubmit([{
      userId,
      email: multiple ? emailAddresses : emailAddresses[0],
    }]);
  }

  return (
    <form onSubmit={handleSubmit}>
      <p className="form-text px-sm-5 mb-5"><FormattedMessage {...messages.sendInvitationByEmail} /></p>
      {emailAddresses.map((email, i) => (
        <Form.Group key={[i]} controlId={`email_${i}`} className="mb-4">
          <Form.Label className="visually-hidden"><FormattedMessage {...messages.emailAddress} /></Form.Label>
          <div className="d-flex">
            <Form.Control
              type="email"
              value={email}
              onChange={(ev) => setEmailAddress(ev.target.value, i)}
              placeholder={intl.formatMessage(messages.emailAddress)}
              required
            />
            {emailAddresses.length > 1 && (
              <IconButton variant="link" icon="ss-delete fs-3 lower-1 opacity-50" className="text-danger" onClick={() => handleRemove(i)} />
            )}
          </div>
        </Form.Group>
      ))}
      {multiple && (
        <Form.Group className="">
          <IconButton type="button" variant="light" icon="ss-plus lower-1" onClick={handleAdd}>
            <FormattedMessage {...messages.addEmail} />
          </IconButton>
        </Form.Group>
      )}
      <Button type="submit" className="my-5" variant="primary"><FormattedMessage {...messages.send} /></Button>
    </form>
  );
}

Individual.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  userId: PropTypes.number,
  multiple: PropTypes.bool,
};

export default Individual;
